export default class Thumbnail {
  constructor({ original = null , originalUrl = null, aspectRatio = 0 }) {
    this.original = original
    this.originalUrl = originalUrl
    this.aspectRatio = aspectRatio
  } 
}